
import { EventEmitter } from 'events';
import type { FirestorePermissionError } from './errors';

type AppEvents = {
  'permission-error': (error: FirestorePermissionError) => void;
};

// We need to extend the EventEmitter to have typed events.
declare interface AppEventEmitter {
  on<E extends keyof AppEvents>(event: E, listener: AppEvents[E]): this;
  emit<E extends keyof AppEvents>(event: E, ...args: Parameters<AppEvents[E]>): boolean;
  off<E extends keyof AppEvents>(event: E, listener: AppEvents[E]): this;
}

class AppEventEmitter extends EventEmitter {}

export const errorEmitter = new AppEventEmitter();
